(() => {
  class EasyTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.buttons = Array.from(this.querySelectorAll('[data-egt-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-egt-panel]'));
      this.scope = this.closest('[data-section-id]') || this;
      this.links = Array.from(this.scope.querySelectorAll('[data-egt-tab-link]'));

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.select(button.dataset.egtTab));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.buttons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.buttons.length) % this.buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.buttons.length - 1;
          const next = this.buttons[nextIndex];
          this.select(next.dataset.egtTab);
          next.focus();
        });
      });
    }

    select(id) {
      this.buttons.forEach((button) => {
        const active = button.dataset.egtTab === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.setAttribute('tabindex', active ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const active = panel.dataset.egtPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      this.links.forEach((link) => {
        const active = link.dataset.egtTabLink === id;
        link.hidden = !active;
        link.style.display = active ? '' : 'none';
      });
    }
  }

  class EasyRail extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-egt-track]');
      this.prev = this.querySelector('[data-egt-prev]');
      this.next = this.querySelector('[data-egt-next]');
      if (!this.track) return;

      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    scroll(direction) {
      const firstCard = this.track.querySelector('.egt-card, .card-wrapper');
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
      const cardWidth = firstCard?.getBoundingClientRect().width || this.track.clientWidth * 0.8;
      const visibleCards = Math.max(1, Math.floor(this.track.clientWidth / Math.max(cardWidth + gap, 1)));
      const amount = (cardWidth + gap) * Math.max(1, visibleCards - 1);
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    update() {
      if (!this.prev || !this.next) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 4);
      this.prev.disabled = this.track.scrollLeft <= 4;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }

  const revealElements = (root = document) => {
    const elements = Array.from(root.querySelectorAll('[data-egt-reveal]:not(.is-visible)'));
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    );

    elements.forEach((element) => observer.observe(element));
  };

  if (!customElements.get('easy-tabs')) customElements.define('easy-tabs', EasyTabs);
  if (!customElements.get('easy-rail')) customElements.define('easy-rail', EasyRail);

  const init = (root = document) => {
    revealElements(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* EASY GAMES · Legacy badge runtime V4 disabled.
 * Badge Engine V5 is the single badge runtime.
 */
